import React, { Component } from 'react';
import { connect } from 'react-redux'
import Auth from '../../Auth/Auth';
import ProfilePicture from "@dsalvagni/react-profile-picture"
import '@dsalvagni/react-profile-picture/dist/ProfilePicture.css';
import { DefaultButton, PrimaryButton} from '@fluentui/react';
import { AUTH_CONFIG } from '../../Auth/auth0-variables';
import axios from 'axios';
import { updateUserProfile } from "../../actions"

import { showToast } from '../../actions'
import PortalComponent from '../../UiKit/SharedComponents/PortalComponent';
import ShiftsContext from '../../Context/ShiftsContext'

const resizeBase64Image = (base64Str, maxWidth = 200, maxHeight = 200) => {
    return new Promise((resolve, reject) => {
        const img = new Image();
        img.onload = () => {
            let canvas = document.createElement('canvas');
            let width = img.width;
            let height = img.height;

            // Resize maintaining aspect ratio
            if (width > height) {
                if (width > maxWidth) {
                    height *= maxWidth / width;
                    width = maxWidth;
                }
            } else {
                if (height > maxHeight) {
                    width *= maxHeight / height;
                    height = maxHeight;
                }
            }

            canvas.width = width;
            canvas.height = height;
            const ctx = canvas.getContext('2d');
            ctx.drawImage(img, 0, 0, width, height);
            const resizedBase64 = canvas.toDataURL('image/png', 0.8); // compress a bit
            resolve(resizedBase64);
        };
        img.onerror = reject;
        img.src = base64Str;
    });
};

export class ProfileImagePicker extends React.Component {
    static contextType = ShiftsContext
    constructor(props) {
        super(props);
        this.auth = new Auth();

        this.state = {
            userImg: this.props.user.userImg
        };
        this.profilePictureRef = React.createRef();
    }

    handleUpload = async () => {
        const { toggleProfilePic } = this.context;
        const PP = this.profilePictureRef.current;
        const imageAsDataURL = PP.getImageAsDataUrl();

        try {
            const resizedBase64 = await resizeBase64Image(imageAsDataURL);

            const model = {
                imageBlob: resizedBase64.replace(/^data:image\/(png|jpeg);base64,/, '')
            };

            axios.post(AUTH_CONFIG.API_URL + "/api/Account/UpdateProfileImage", model)
                .then((response) => {
                    if (response.status === 200) {
                        this.props.user.userImg = response.data;
                        this.props.dispatch(updateUserProfile(this.props.user));

                        this.setState({
                            showModal: false,
                            userImg: response.data
                        }, () => {
                            toggleProfilePic();
                        });
                    }
                });
        } catch (error) {
            console.error("Failed to resize image:", error);
            this.props.dispatch(showToast("Error resizing image"));
        }
    };


    onCloseModal = () => {
        const { toggleProfilePic } = this.context
        toggleProfilePic()
    };

    render() {
        return (
            <PortalComponent>
                <div className="profile-image-picker box overlay-spinner-container dark">
                    <main className="modal-container flexcolumn dashboard-card2 white-to-grey pb20">
                    <ProfilePicture
                            ref={this.profilePictureRef}
                            useHelper={true}
                            debug={true}
                            frameFormat="circle"
                    />
                    <div className="displayflex justifycenter">
                        <PrimaryButton className="mr5" onClick={() => this.handleUpload()} text="Upload" />
                        <DefaultButton className="ml5" onClick={() => this.onCloseModal()} text="Discard" />
                    </div>
                    </main>
                </div>
            </PortalComponent>
        );
    }
}

const mapStateToProps = state => ({
    user: state.userProfile
});

export default connect(mapStateToProps)(ProfileImagePicker);



